import * as React from "react";
import Collapsible from "react-collapsible";
import { useHistory, Link } from "react-router-dom";

// Components
import Button from "../Button/Button";
import IconArrowDown from "../Icons/IconArrowDown";

const FloatingNavigation: React.FC = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = React.useState(false);

  const triggerElement = (
    <div className="flex items-center justify-between cursor-pointer">
      <p className="font-bold text-white text-s">Get Results</p>
      <IconArrowDown
        className="transition-transform ease-out duration-300"
        style={{
          transform: `${isOpen ? "rotate(0deg)" : "rotate(180deg)"}`,
        }}
      />
    </div>
  );

  return (
    <div className="fixed w-full sm:w-1/2 lg:w-2/5 xl:w-1/3 sm:right-0 bottom-0 bg-dw-grey-12 py-2 z-10">
      <div className="mx-auto" style={{ maxWidth: "1440px" }}>
        <div className="w-11/12 mx-auto">
          <Collapsible
            trigger={triggerElement}
            open={isOpen}
            easing="cubic-bezier(0.5, 1, 0.89, 1)"
            onOpening={() => setIsOpen(true)}
            onClosing={() => setIsOpen(false)}
          >
            <div className="xl:flex mt-2 mb-3">
              <Link
                className="block text-center bg-dw-grey-03 text-dw-blue w-full sm:mx-auto sm:block px-4 py-2 text-s font-bold hover:bg-dw-blue hover:text-white mb-3 xl:mb-0 md:mr-3 md:ml-auto sm:w-full md:w-full "
                to="/finish"
              >
                Finish Policy
              </Link>
              <Button
                type="button"
                className="mb-3 md:mb-0 md:mr-1 md:ml-0 sm:w-full md:w-full"
                onClick={async () => {
                  history.push("/save");
                }}
              >
                Save Progress
              </Button>
            </div>
          </Collapsible>
        </div>
      </div>
    </div>
  );
};

export default FloatingNavigation;
